import React, { useMemo } from 'react';
import { Button } from '@sezzle/sezzle-mui';
import styled from 'styled-components';
import { SezzleButtonProps } from './types';
import { setPrefix } from '../../../utils/helpers';
import { defaultLocale } from '../../types/constants';
import { CTASelections } from '../../types/enums';
import sezzleTheme from '../../../../../packages/website/src/templates/Page/themes';

const isBrowser = typeof window !== 'undefined';

const StyledButton = styled(Button)`
  font-family: ${sezzleTheme.bodyFont};
`;

const SezzleButton = ({
  node_locale, url, style, displayText, buttonSize = 'large', className, onClick, fullWidth, ...props
}: SezzleButtonProps) => {
  const localePrefix = node_locale && node_locale === defaultLocale ? '' : `/${node_locale?.toLowerCase()}`;
  let setURL = !url?.startsWith('/') ? setPrefix(props.function, url) : `${localePrefix}${url}` || `${localePrefix}${url}`;
  if (isBrowser && url === '{{af_smart_script_link}}' && window.result && window.result.clickURL) {
    setURL = result.clickURL;
  }

  const customVariant = useMemo(() => {
    switch (style) {
      case CTASelections.PrimaryButton:
        return 'contained';
      case CTASelections.SecondaryButton:
        return 'outlined';
      default:
        return 'primary';
    }
  }, []);

  return (
    <StyledButton
      data-testid="buttonAnchor"
      data-component-type="button-styled-link"
      href={setURL}
      color="primary"
      variant={customVariant || 'contained'}
      size={buttonSize}
      fullWidth={fullWidth}
      onClick={onClick}
      className={className}
    >
      {displayText}
    </StyledButton>
  );
};

export default SezzleButton;
